// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__q+5mY"};